/**
 * 开放平台外链（与 `indexHeader.vue` 保持一致）
 * @param {object} util - `@/util/util.js` 默认导出
 * @returns {{ cloudPlatform: string, salesSystem: string }}
 */
export function getOpenPlatformLinks (util) {
  const base = util.config.url
  return {
    cloudPlatform: `${base}/djxwork/#/`,
    salesSystem: `${base}/salesSystem/#/login`
  }
}

/**
 * @param {object} util
 * @returns {import('./atsNavConfig').AtsNavItem}
 */
function getOpenPlatformNavItem (util) {
  const links = getOpenPlatformLinks(util)
  return {
    id: 'open',
    label: '开放平台',
    href: '#',
    kind: 'dropdown',
    target: '',
    children: [
      {
        id: 'open-cloud',
        label: '救援云平台',
        href: links.cloudPlatform,
        kind: 'external',
        target: links.cloudPlatform
      },
      {
        id: 'open-sales',
        label: '分销系统',
        href: links.salesSystem,
        kind: 'external',
        target: links.salesSystem
      }
    ]
  }
}

/**
 * 品牌落地页 / 全球救援 / 救援清单 / 健康监测 / 急救包产品 共用顶部导航配置
 * @param {object} util - `@/util/util.js` 默认导出
 * @param {'savior'|'globalRescue'|'rescueList'|'healthMonitoring'|'firstAidKit'|'companyIntro'} page - 当前页面
 * @returns {Array<import('./atsNavConfig').AtsNavItem>}
 */
export function getAtsNavItems (util, page) {
  const saviorPath = '/about-the-savior'
  const rescueListPath = '/rescue-list'
  const healthPath = '/health-monitoring'
  const firstAidPath = '/first-aid-kit'

  const healthNav = { id: 'health', label: '健康监测', href: healthPath, kind: 'route', target: healthPath }
  const aidNav = { id: 'aid', label: '急救包产品', href: firstAidPath, kind: 'route', target: firstAidPath }

  const standardNav = [
    { id: 'about', label: '关于大救星', href: saviorPath, kind: 'route', target: saviorPath },
    { id: 'global', label: '全球救援', href: '/global-rescue', kind: 'route', target: '/global-rescue' },
    { id: 'list', label: '救援清单', href: rescueListPath, kind: 'route', target: rescueListPath },
    healthNav,
    aidNav,
    { id: 'company', label: '公司介绍', href: '/company-intro', kind: 'route', target: '/company-intro' },
    getOpenPlatformNavItem(util)
  ]

  if (page === 'globalRescue' || page === 'rescueList' || page === 'healthMonitoring' || page === 'firstAidKit' || page === 'companyIntro') {
    return standardNav
  }

  return [
    { id: 'about', label: '关于大救星', href: saviorPath, kind: 'top', target: saviorPath },
    { id: 'global', label: '全球救援', href: '/global-rescue', kind: 'route', target: '/global-rescue' },
    { id: 'list', label: '救援清单', href: rescueListPath, kind: 'route', target: rescueListPath },
    healthNav,
    aidNav,
    { id: 'company', label: '公司介绍', href: '/company-intro', kind: 'route', target: '/company-intro' },
    getOpenPlatformNavItem(util)
  ]
}

import { preloadAtsPageByPath } from '@/util/atsImagePreload'

/**
 * 导航点击：滚动 / 路由（含 hash）/ 外链
 * @param {import('vue-router').default} router - Vue Router 实例
 * @param {{ kind: string, target: string, hash?: string }} item - 导航项
 * @returns {void}
 */
export function handleAtsNavClick (router, item) {
  if (item.kind === 'top') {
    if (router.currentRoute.path !== item.target) {
      router.push(item.target).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  } else if (item.kind === 'scroll') {
    const el = document.getElementById(item.target)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  } else if (item.kind === 'route') {
    const scrollTopInstant = () => {
      window.scrollTo(0, 0)
    }
    const navigate = () => {
      const isSamePath = router.currentRoute.path === item.target
      if (item.hash) {
        router.push({ path: item.target, hash: `#${item.hash}` }).then(() => {
          scrollTopInstant()
          setTimeout(() => {
            const el = document.getElementById(item.hash)
            if (el) {
              el.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 120)
        })
      } else if (isSamePath) {
        scrollTopInstant()
      } else {
        router.push(item.target).then(scrollTopInstant)
      }
    }
    preloadAtsPageByPath(item.target).then(navigate)
  } else if (item.kind === 'external') {
    window.open(item.target, '_blank', 'noopener,noreferrer')
  }
}



// WEBPACK FOOTER //
// ./src/util/atsNavConfig.js